import React, { useContext } from "react";
import loadable from "@loadable/component";
import clsx from "clsx";
import UiContext from "@UiContext";

import styles from "./Footer.styles";

const Contact = loadable(() => import("./Contact"));
const Container = loadable(() => import("@Components/views/Container"));
const Footermenu = loadable(() => import("./Footermenu"));
const Map = loadable(() => import("./Map"));
const Metamenu = loadable(() => import("./Metamenu"));
const Micado = loadable(() => import("./Micado"));
const ScrollToTopButton = loadable(() => import("./ScrollToTopButton"));

const Footer = ({ lang }) => {
	const css = styles();
	const [ui] = useContext(UiContext);
	const {
		_settings: { footer = {} }
	} = ui;
	const { maxWidth } = footer || {};

	return (
		<div className={clsx(css.footer, "mco-view-component-footer")}>
			<ScrollToTopButton />
			<div className={clsx(css.wrapper, "mco-view-component-footer__wrapper")}>
				<Container
					className={clsx(css.container, "mco-view-component-footer__container")}
					maxWidth={maxWidth}
				>
					<div className={clsx(css.top, "mco-view-component-footer__top")}>
						<Contact />
						<Map />
						<Footermenu />
					</div>
					<div className={clsx(css.bottom, "mco-view-component-footer__bottom")}>
						<Metamenu />
						<Micado />
					</div>
				</Container>
			</div>
		</div>
	);
};

export default Footer;
